module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/two-fa-control/two-fa-control.component.html
// module id = ./web/modern/components/2fa/two-fa-control/two-fa-control.component.html
// module chunks = 0